/* WITHOUTSTANDING flagship — theme behaviour.
   Enhancement only: content, links, price and purchase remain real HTML
   without JS (product form falls back to a normal POST to /cart/add). */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- header ---------- */
  var header = document.querySelector('.fl-header');
  var heroEl = document.querySelector('.hero');
  function setHeader() {
    if (!header) return;
    if (getComputedStyle(header).position === 'sticky') { header.classList.add('solid'); return; }
    var threshold = heroEl ? heroEl.offsetHeight - 80 : 10;
    header.classList.toggle('solid', window.scrollY > (heroEl ? threshold : 10));
  }
  window.addEventListener('scroll', setHeader, { passive: true });
  setHeader();

  var menuBtn = document.querySelector('.menu-btn');
  var nav = document.querySelector('.main-nav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', String(open));
      if (open) header.classList.add('solid'); else setHeader();
    });
  }

  /* mobile uses the art-directed still — never download the desktop film */
  /* Desktop film: built only here, only >=701px, only at idle. The server
     sends no video element at all, so the mobile path stays photo-only. */
  var heroSlot = document.querySelector('[data-hero-video]');
  var isTouchDevice = window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches;
  if (heroSlot && window.matchMedia('(min-width: 701px)').matches && !isTouchDevice && !reduceMotion.matches) {
    var buildHeroFilm = function () {
      var v = document.createElement('video');
      v.className = 'autoplay-video hero-video-desktop';
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.setAttribute('aria-hidden', 'true'); v.tabIndex = -1;
      v.preload = 'auto';
      var s = document.createElement('source');
      s.src = heroSlot.getAttribute('data-hero-video'); s.type = 'video/mp4';
      v.appendChild(s);
      heroSlot.parentNode.replaceChild(v, heroSlot);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (e.isIntersecting) { var q = e.target.play(); if (q && q.catch) q.catch(function () {}); }
            else e.target.pause();
          });
        }, { threshold: 0.15 }).observe(v);
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) v.pause(); });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(buildHeroFilm, { timeout: 3000 });
    else setTimeout(buildHeroFilm, 1500);
  }

  /* ---------- homepage mobile sticky access ---------- */
  var homeSticky = document.querySelector('.home-sticky');
  if (homeSticky && heroEl) {
    var footerEl = document.querySelector('.site-footer');
    var chooseEl = document.querySelector('.choose');
    var nearEnd = false;
    if ('IntersectionObserver' in window && footerEl) {
      var fio = new IntersectionObserver(function (en) {
        nearEnd = en.some(function (e) { return e.isIntersecting; });
        setHomeSticky();
      }, { rootMargin: '120px' });
      fio.observe(footerEl);
      if (chooseEl) fio.observe(chooseEl);
    }
    function setHomeSticky() {
      var past = window.scrollY > heroEl.offsetHeight - 40;
      homeSticky.classList.toggle('show', past && !nearEnd);
    }
    window.addEventListener('scroll', setHomeSticky, { passive: true });
    setHomeSticky();
  }

  /* ---------- deferred images: bytes only on approach ---------- */
  var hydrateImg = function (im) {
    if (!im || !im.dataset || !im.dataset.src) return;
    if (im.dataset.sizes) im.sizes = im.dataset.sizes;
    if (im.dataset.srcset) im.srcset = im.dataset.srcset;
    im.src = im.dataset.src;
    delete im.dataset.src;
  };

  /* Download throttle: never start more than two below-fold images at once.
     Whichever image sits highest in the document goes first, so the first image
     you meet in a section is always the one being fetched, and a section with
     four details no longer fires all four in the same moment. */
  var MAX_IMG_CONCURRENCY = 2;
  var imgInflight = 0;
  var imgQueue = [];
  var pumpImages = function () {
    while (imgInflight < MAX_IMG_CONCURRENCY && imgQueue.length) {
      imgQueue.sort(function (a, b) {
        return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
      });
      var im = imgQueue.shift();
      if (!im || !im.dataset || !im.dataset.src) continue;
      /* The image nearest the top — the first one you meet in a section — gets the
         high hint; anything sharing the pipe with it yields. */
      try { im.fetchPriority = (imgInflight === 0) ? 'high' : 'low'; } catch (e) {}
      imgInflight++;
      var release = function () { imgInflight--; pumpImages(); };
      im.addEventListener('load', release, { once: true });
      im.addEventListener('error', release, { once: true });
      hydrateImg(im);
    }
  };
  var queueImg = function (im) {
    if (!im || !im.dataset || !im.dataset.src) return;
    if (imgQueue.indexOf(im) === -1) imgQueue.push(im);
    pumpImages();
  };
  (function () {
    var deferred = Array.prototype.slice.call(document.querySelectorAll('img[data-src]')).filter(function (im) {
      return !im.closest('[data-track]') && !im.closest('.positions-media');
    });
    if (!deferred.length) return;
    /* Attach the observer only AFTER the hero has painted, so below-fold media never
       competes with the LCP image for bandwidth. Once armed, a generous rootMargin
       loads each image roughly 1.5 viewports before it is reached, so normal
       scrolling does not expose blank media. */
    var arm = function () {
      if ('IntersectionObserver' in window) {
        var lio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { queueImg(e.target); lio.unobserve(e.target); }
          });
        }, { rootMargin: '1500px 0px' });
        deferred.forEach(function (im) { lio.observe(im); });
      } else deferred.forEach(hydrateImg);
    };
    var start = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(arm, { timeout: 1200 });
      else setTimeout(arm, 200);
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  })();

  /* ---------- reveal grammar ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- autoplay video management ---------- */
  var vids = document.querySelectorAll('video[data-autoplay]');
  if (vids.length) {
    var play = function (v) {
      if (reduceMotion.matches) return;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    };
    /* Video bytes only after the browser is idle: stills and text win first. */
    var attachPoster = function (v) {
      if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; }
    };
    var armVideos = function () {
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { attachPoster(e.target); play(e.target); } else e.target.pause();
          });
        }, { threshold: 0.15 });
        vids.forEach(function (v) { vio.observe(v); });
      } else vids.forEach(function (v) { attachPoster(v); play(v); });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(armVideos, { timeout: 2500 });
    else setTimeout(armVideos, 1200);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) vids.forEach(function (v) { v.pause(); });
    });
    if (reduceMotion.matches) vids.forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); });
    document.querySelectorAll('.vid-pause').forEach(function (btn) {
      var v = btn.parentElement.querySelector('video');
      if (!v) return;
      btn.addEventListener('click', function () {
        if (v.paused) { v.play().catch(function () {}); btn.textContent = '❚❚'; btn.setAttribute('aria-label', 'Pause video'); }
        else { v.pause(); btn.textContent = '►'; btn.setAttribute('aria-label', 'Play video'); }
      });
    });
  }

  /* ---------- four positions selector ---------- */
  var positions = document.querySelector('[data-positions]');
  if (positions) {
    var items = Array.prototype.slice.call(positions.querySelectorAll('.position-item'));
    var imgs = Array.prototype.slice.call(positions.querySelectorAll('.positions-media img'));
    var curP = 0, posSeen = false;
    var posMedia = positions.querySelector('.positions-media');
    if (posMedia && 'IntersectionObserver' in window) {
      var pio = new IntersectionObserver(function (en) {
        if (en.some(function (e) { return e.isIntersecting; })) {
          posSeen = true; hydrateImg(imgs[curP]); pio.disconnect();
        }
      }, { rootMargin: '1200px 0px' });
      if (document.readyState === 'complete') pio.observe(posMedia);
      else window.addEventListener('load', function () { pio.observe(posMedia); }, { once: true });
    } else { posSeen = true; hydrateImg(imgs[0]); }
    var triggers = items.map(function (it) { return it.querySelector('.position-trigger'); });
    var activateP = function (i, focus) {
      items.forEach(function (it, j) {
        var on = i === j;
        it.classList.toggle('active', on);
        triggers[j].setAttribute('aria-expanded', String(on));
      });
      curP = i;
      imgs.forEach(function (im, j) {
        im.classList.toggle('active', i === j);
        if (i === j && posSeen) hydrateImg(im);
      });
      if (focus) triggers[i].focus();
    };
    triggers.forEach(function (t, i) {
      t.addEventListener('click', function () { activateP(i); });
      t.addEventListener('keydown', function (ev) {
        var n = null;
        if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') n = (i + 1) % triggers.length;
        if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') n = (i - 1 + triggers.length) % triggers.length;
        if (ev.key === 'Home') n = 0;
        if (ev.key === 'End') n = triggers.length - 1;
        if (n !== null) { ev.preventDefault(); activateP(n, true); }
      });
    });
    activateP(0);
  }

  /* ---------- positions: size select → single Add to bag ---------- */
  document.querySelectorAll('[data-pos-buy]').forEach(function (buy) {
    var addBtn = buy.querySelector('[data-pos-add]');
    var sizes = Array.prototype.slice.call(buy.querySelectorAll('[data-pos-size]'));
    var chosen = null;
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        chosen = b;
        sizes.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('selected', on);
          x.setAttribute('aria-pressed', String(on));
        });
        addBtn.disabled = false;
        addBtn.textContent = 'Add to bag — ' + b.dataset.size;
      });
    });
    addBtn.addEventListener('click', function () {
      if (!chosen) return;
      addVariant(chosen.dataset.posSize, buy.dataset.statement + ', size ' + chosen.dataset.size);
    });
  });

  /* ---------- PDP carousel: one frame, dots, discreet desktop arrows ---------- */
  var carousel = document.querySelector('[data-carousel]');
  if (carousel) {
    var track = carousel.querySelector('[data-track]');
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-dot]'));
    var slideW = function () { var s = track.querySelector('[data-slide]'); return s ? s.getBoundingClientRect().width : track.clientWidth; };
    var index = function () { var w = slideW(); return w ? Math.round(track.scrollLeft / w) : 0; };
    /* A direct dot-jump must not hydrate the slides the smooth scroll passes:
       while a far jump is in flight, path hydration is suppressed until the
       target lands. Any real touch/wheel input cancels the suppression. */
    var jumpTarget = null;
    var sync = function () {
      var i = index();
      if (jumpTarget === null) hydrateAround(i);
      else if (i === jumpTarget) { jumpTarget = null; hydrateAround(i); }
      dots.forEach(function (d, n) {
        var on = n === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', String(on));
      });
      var cnt = carousel.querySelector('[data-count]');
      if (cnt) cnt.textContent = String(i + 1);
    };
    var go = function (i) {
      if (Math.abs(i - index()) > 1) jumpTarget = i;
      hydrateAround(i);
      track.scrollTo({ left: i * slideW(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { jumpTarget = null; }, { passive: true });
    });
    /* progressive gallery loader: only current, previous and next slides carry real URLs */
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var hydrate = function (i) {
      var s = slides[i]; if (!s) return;
      var im = s.querySelector('img[data-src]');
      if (!im) return;
      im.sizes = im.getAttribute('data-sizes') || '100vw';
      im.srcset = im.getAttribute('data-srcset') || '';
      im.src = im.getAttribute('data-src');
      im.removeAttribute('data-src');
    };
    var hydrateAround = function (i) { hydrate(i); hydrate(i + 1); hydrate(i - 1); };
    hydrateAround(0);
    track.addEventListener('scroll', sync, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dot'), 10)); }); });
    var prev = carousel.querySelector('[data-prev]');
    var next = carousel.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, index() - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(dots.length - 1, index() + 1)); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(dots.length - 1, index() + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, index() - 1)); }
    });

    /* ---------- tap-to-enlarge (native <dialog>, no library) ---------- */
    var lb = document.querySelector('[data-lightbox]');
    var zoomBtn = carousel.querySelector('[data-zoom]');
    if (lb && typeof lb.showModal === 'function') {
      var lbImg = lb.querySelector('[data-lightbox-img]');
      var lbStage = lb.querySelector('[data-lightbox-stage]');
      var lbCount = lb.querySelector('[data-lightbox-count]');
      var lbAt = 0;
      var bigSrc = function (im) {
        var set = im.getAttribute('srcset') || im.getAttribute('data-srcset') || '';
        var parts = set.split(',').map(function (x) { return x.trim().split(/\s+/)[0]; }).filter(Boolean);
        var u = parts.length ? parts[parts.length - 1] : (im.currentSrc || im.getAttribute('src') || im.getAttribute('data-src'));
        /* Shopify CDN images can be asked for more pixels; theme assets are used as-is. */
        return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, function (m, a) { return a + '2200'; }) : u;
      };
      var show = function (i) {
        var s = slides[i]; if (!s) return;
        lbAt = i;
        var im = s.querySelector('img');
        lb.classList.remove('is-zoomed');
        lbImg.src = bigSrc(im);
        lbImg.alt = im.getAttribute('alt') || '';
        if (lbCount) lbCount.textContent = (i + 1) + ' / ' + slides.length;
      };
      var openLb = function () {
        show(index());
        lb.showModal();
        document.body.style.overflow = 'hidden';
      };
      if (zoomBtn) zoomBtn.addEventListener('click', openLb);
      track.addEventListener('click', function (e) { if (e.target.tagName === 'IMG') openLb(); });
      lb.addEventListener('close', function () { document.body.style.overflow = ''; go(lbAt); if (zoomBtn) zoomBtn.focus({ preventScroll: true }); });
      lb.querySelector('[data-lightbox-close]').addEventListener('click', function () { lb.close(); });
      lb.querySelector('[data-lightbox-prev]').addEventListener('click', function () { show((lbAt - 1 + slides.length) % slides.length); });
      lb.querySelector('[data-lightbox-next]').addEventListener('click', function () { show((lbAt + 1) % slides.length); });
      lbStage.addEventListener('click', function (e) {
        if (e.target !== lbImg) { lb.close(); return; }
        var r = lbImg.getBoundingClientRect();
        var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        lb.classList.toggle('is-zoomed');
        if (lb.classList.contains('is-zoomed')) {
          lbStage.scrollLeft = fx * lbStage.scrollWidth - lbStage.clientWidth / 2;
          lbStage.scrollTop = fy * lbStage.scrollHeight - lbStage.clientHeight / 2;
        }
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show((lbAt + 1) % slides.length);
        if (e.key === 'ArrowLeft') show((lbAt - 1 + slides.length) % slides.length);
      });
    } else if (zoomBtn) {
      zoomBtn.hidden = true;
    }
  }

  /* ======================================================================
     PURCHASE PATH — 25 Sep 2026 conversion reset.
     One add function for every entry point (PDP, positions, THE TWO, THE FOUR),
     visible loading + error states, a bag that shows what the customer is
     actually paying (per-line discounts, savings), in-place size/quantity edits,
     and a size that stays in sync between the buy panel and the sticky bar.
     ====================================================================== */
  var OFFER = window.WS_OFFER || { regular: false, products: {} };

  /* Purchase intent: once a customer is choosing a size or has a bag, the
     FIRST ACCESS popup must not interrupt (read by ws-first-access). */
  function markIntent() {
    window.__wsIntent = true;
    try { sessionStorage.setItem('ws_intent', '1'); } catch (e) {}
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.size-options, .ws-two, .pos-sizes')) markIntent();
  });

  /* ---------- in-page size guide ---------- */
  document.querySelectorAll('[data-size-guide]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var fit = document.getElementById('pdp-fit');
      if (!fit) return; // no fit table on this page: follow the link to /pages/size-guide
      e.preventDefault();
      fit.open = true;
      fit.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      var sum = fit.querySelector('summary'); if (sum) window.setTimeout(function () { sum.focus({ preventScroll: true }); }, 450);
    });
  });

  /* ---------- size tables: cm / inches (computed, one decimal) ---------- */
  document.querySelectorAll('.unit-toggle').forEach(function (tg) {
    var table = tg.parentElement.querySelector('table[data-units]');
    if (!table) return;
    tg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-unit]'); if (!b) return;
      var inches = b.dataset.unit === 'in';
      tg.querySelectorAll('[data-unit]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      table.querySelectorAll('td[data-cm]').forEach(function (td) {
        var cm = parseFloat(td.dataset.cm);
        td.textContent = inches ? (Math.round(cm / 2.54 * 10) / 10) + '″' : String(cm);
      });
    });
  });

  /* ---------- compare with your favourite tee (nothing leaves the page) ---------- */
  document.querySelectorAll('[data-fit-compare]').forEach(function (box) {
    var sizes = {}; try { sizes = JSON.parse(box.dataset.sizes); } catch (e) { return; }
    var aIn = box.querySelector('[data-fit-a]'), bIn = box.querySelector('[data-fit-b]'), out = box.querySelector('[data-fit-out]');
    var unit = 'cm';
    var fmt = function (cm) {
      var v = unit === 'in' ? Math.round(Math.abs(cm) / 2.54 * 10) / 10 : Math.round(Math.abs(cm) * 10) / 10;
      return v + (unit === 'in' ? ' in' : ' cm');
    };
    var say = function (diff, more, less, same) {
      if (Math.abs(diff) < 0.5) return same;
      return fmt(diff) + ' ' + (diff > 0 ? more : less);
    };
    var run = function () {
      var a = parseFloat(aIn.value), l = parseFloat(bIn.value);
      if (unit === 'in') { a = a * 2.54; l = l * 2.54; }
      if (!(a > 20 && a < 120) && !(l > 30 && l < 150)) {
        out.innerHTML = '<p class="ws-fit__hint">Enter A and B to see how each DROP 001 size compares with your tee.</p>';
        return;
      }
      var rows = Object.keys(sizes).map(function (k) {
        var parts = [];
        if (a > 20 && a < 120) parts.push(say(sizes[k][0] - a, 'wider across the chest', 'narrower across the chest', 'about the same width across the chest'));
        if (l > 30 && l < 150) parts.push(say(sizes[k][1] - l, 'longer', 'shorter', 'about the same length'));
        return { k: k, t: parts.join(' and '), d: (a > 20 ? Math.abs(sizes[k][0] - a) : 0) };
      });
      var closest = (a > 20 && a < 120) ? rows.slice().sort(function (x, y) { return x.d - y.d; })[0].k : null;
      out.innerHTML = '<ul class="ws-fit__list">' + rows.map(function (r) {
        return '<li' + (r.k === closest ? ' class="is-closest"' : '') + '><b>' + r.k + '</b><span>Compared with your tee, ' + r.k + ' is ' + r.t + '.</span></li>';
      }).join('') + '</ul>' + (closest ? '<p class="ws-fit__hint">Closest to your tee across the chest: <b>' + closest + '</b>. That is a comparison, not a guarantee of fit.</p>' : '');
    };
    box.addEventListener('input', run);
    box.querySelectorAll('[data-fit-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.dataset.fitUnit; if (next === unit) return;
        [aIn, bIn].forEach(function (inp) { var v = parseFloat(inp.value); if (v > 0) inp.value = next === 'in' ? Math.round(v / 2.54 * 10) / 10 : Math.round(v * 2.54 * 10) / 10; });
        unit = next;
        box.querySelectorAll('[data-fit-unit]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === btn)); });
        aIn.placeholder = unit === 'in' ? 'e.g. 23' : 'e.g. 58'; bIn.placeholder = unit === 'in' ? 'e.g. 28' : 'e.g. 71';
        run();
      });
    });
  });
  document.querySelectorAll('[data-fit-jump]').forEach(function (a) {
    a.addEventListener('click', function () {
      var wrap = document.getElementById('pdp-fitcompare'); if (wrap) wrap.open = true;
      var inp = document.querySelector('#pdp-fit [data-fit-a]');
      if (inp) window.setTimeout(function () { inp.focus({ preventScroll: true }); }, 600);
    });
  });

  /* ---------- product cards: Back / Worn / Front, by tap or swipe ---------- */
  document.querySelectorAll('[data-card-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-card-track]');
    var btns = Array.prototype.slice.call(g.querySelectorAll('[data-card-view]'));
    if (!track || !btns.length) return;
    var slidesN = track.children.length;
    var setPressed = function (i) { btns.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.cardView === i)); }); };
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Math.min(+b.dataset.cardView, slidesN - 1);
        var sl = track.children[i];
        sl.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
        track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        setPressed(i);
      });
    });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      setPressed(i);
    }, { passive: true });
  });

  /* checkout underway: never interrupt it with FIRST ACCESS */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.cart-checkout, [name="checkout"], a[href*="/checkout"]')) markIntent();
  });

  /* ---------- bag drawer ---------- */
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-overlay');
  var closeBtn = document.querySelector('.cart-close');
  var itemsEl = document.querySelector('.cart-items');
  var footEl = document.querySelector('[data-cart-foot]');
  var msgEl = document.querySelector('[data-cart-msg]');
  var upsellEl = document.querySelector('[data-cart-upsell]');
  var savingsRow = document.querySelector('[data-cart-savings-row]');
  var savingsEl = document.querySelector('[data-cart-savings]');
  var twoRow = document.querySelector('[data-cart-two-row]');
  var twoLabel = document.querySelector('[data-cart-two-label]');
  var twoEl = document.querySelector('[data-cart-two]');
  var countEls = document.querySelectorAll('.cart-count');
  var cartBtns = document.querySelectorAll('[data-cart-open]');
  var totalEl = document.querySelector('[data-cart-total]');
  var live = document.getElementById('cart-live');
  var lastFocus = null;
  var lastCart = null;
  var lastGroups = [];
  var busy = false;

  function announce(msg) {
    if (live) { live.textContent = ''; window.setTimeout(function () { live.textContent = msg; }, 60); }
  }
  function money(cents) {
    return '£' + (cents % 100 === 0 ? (cents / 100) : (cents / 100).toFixed(2));
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function cartError(r) {
    return r.json().catch(function () { return {}; }).then(function (j) {
      var m = (j && (j.description || j.message)) || 'Something went wrong — please try again.';
      if (typeof m !== 'string') m = 'Something went wrong — please try again.';
      var err = new Error(m); err.status = r.status; throw err;
    });
  }
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function showMsg(text) {
    if (!msgEl) return;
    msgEl.textContent = text || '';
    msgEl.hidden = !text;
  }
  function discountLabel(title) {
    var t = String(title || '');
    if (/SEPTEMBER/i.test(t)) return 'September price';
    if (/THE TWO/i.test(t)) return 'The Two';
    return t;
  }
  function lineName(i) {
    if (i.handle === OFFER.fourHandle) return OFFER.regular ? 'The Four' : (i.product_title || '').replace('DROP 001 — ', '');
    return (i.product_title || '').replace('DROP 001 — ', '');
  }
  function sizeSelect(i) {
    var vs = OFFER.products && OFFER.products[i.handle];
    if (!vs || vs.length < 2) return '<span class="ci-meta-size">Size ' + esc(i.variant_title) + '</span>';
    var id = 'ci-size-' + i.key.replace(/[^a-z0-9]/gi, '').slice(0, 24);
    return '<label class="ci-size" for="' + id + '"><span>Size</span>' +
      '<select id="' + id + '" data-line-size="' + esc(i.key.replace(/^g/, '')) + '" data-qty="' + i.quantity + '" aria-label="Size for ' + esc(lineName(i)) + '">' +
      vs.map(function (v) {
        var cur = v.id === i.variant_id;
        return '<option value="' + v.id + '"' + (cur ? ' selected' : '') + (!v.a && !cur ? ' disabled' : '') + '>' + esc(v.t) + (!v.a && !cur ? ' — sold out' : '') + '</option>';
      }).join('') + '</select></label>';
  }
  function renderCart(cart) {
    lastCart = cart;
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    cartBtns.forEach(function (b) { b.setAttribute('aria-label', 'Open bag, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items')); });
    if (totalEl) totalEl.textContent = money(cart.total_price);
    var twoTotal = 0, pairs = 0;
    cart.items.forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        if (a.amount > 0 && /THE TWO/i.test(a.discount_application && a.discount_application.title)) twoTotal += a.amount;
      });
    });
    if (OFFER.twoSaving) pairs = Math.round(twoTotal / OFFER.twoSaving);
    if (twoRow) {
      twoRow.hidden = !(twoTotal > 0);
      if (twoLabel) twoLabel.textContent = pairs > 1 ? 'The Two × ' + pairs : 'The Two';
      if (twoEl) twoEl.textContent = twoTotal > 0 ? '−' + money(twoTotal) : '';
    }
    if (savingsRow) {
      var saved = (cart.total_discount || 0) - twoTotal;
      savingsRow.hidden = !(saved > 0);
      if (savingsEl) savingsEl.textContent = saved > 0 ? '−' + money(saved) : '';
    }
    if (footEl) footEl.hidden = !cart.items.length;
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a class="btn btn-ink" href="/collections/drop-001">Shop the four statements</a></div>';
      if (upsellEl) upsellEl.hidden = true;
      return;
    }
    /* Group lines of the same variant + properties: a pair discount makes
       Shopify split one tee into several lines, which reads as a mistake. */
    var groups = [], byKey = {};
    cart.items.forEach(function (it, idx) {
      var gk = it.variant_id + '|' + JSON.stringify(it.properties || {});
      if (!byKey[gk]) {
        byKey[gk] = { first: it, lines: [], quantity: 0, original_line_price: 0, final_line_price: 0, allocs: [] };
        groups.push(byKey[gk]);
      }
      var g = byKey[gk];
      g.lines.push({ index: idx + 1, quantity: it.quantity });
      g.quantity += it.quantity;
      g.original_line_price += it.original_line_price;
      g.final_line_price += it.final_line_price;
      g.allocs = g.allocs.concat(it.line_level_discount_allocations || []);
    });
    lastGroups = groups;
    itemsEl.innerHTML = groups.map(function (g, gi) {
      var i = Object.assign({}, g.first, { quantity: g.quantity, original_line_price: g.original_line_price, final_line_price: g.final_line_price, line_level_discount_allocations: g.allocs, key: 'g' + gi });
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') : '';
      var name = lineName(i);
      var isFour = i.handle === OFFER.fourHandle;
      var meta = isFour ? 'SELF DEFINED · NO JUSTIFICATION · WITHOUT PERMISSION · ZERO APOLOGIES — all size ' + esc(i.variant_title) : 'Seedpearl · 280 GSM';
      /* THE TWO is a pair discount: Shopify books the £19 on one tee of the pair.
         Showing it on that line reads as "one tee costs £50", so it is added
         back here and shown once, as its own row above the subtotal. Per-item
         discounts (e.g. September's) stay on their line. */
      var allocs = (i.line_level_discount_allocations || []).filter(function (a) { return a.amount > 0; });
      var twoAmt = 0;
      var own = allocs.filter(function (a) {
        var isTwo = /THE TWO/i.test(a.discount_application && a.discount_application.title);
        if (isTwo) twoAmt += a.amount;
        return !isTwo;
      });
      var shown = i.final_line_price + twoAmt;
      var discounted = shown < i.original_line_price;
      var merged = {};
      own.forEach(function (a) { var t = discountLabel(a.discount_application && a.discount_application.title); merged[t] = (merged[t] || 0) + a.amount; });
      var discHtml = Object.keys(merged).map(function (t) {
        return '<p class="ci-disc">' + esc(t) + ' · −' + money(merged[t]) + '</p>';
      }).join('');
      var maxed = i.quantity_rule && i.quantity_rule.max && i.quantity >= i.quantity_rule.max;
      return '<div class="cart-item" data-line="' + esc(i.key) + '">' +
        (img ? '<a class="ci-img" href="' + esc(i.url) + '"><img src="' + esc(img) + '" alt="" width="76" height="100"></a>' : '<span></span>') +
        '<div class="ci-main"><p class="ci-name"><a href="' + esc(i.url) + '">' + esc(name) + '</a></p>' +
        '<p class="ci-meta">' + meta + '</p>' +
        sizeSelect(i) +
        '<div class="ci-qty" role="group" aria-label="Quantity for ' + esc(name) + ' size ' + esc(i.variant_title) + '">' +
        '<button type="button" data-group="' + gi + '" data-op="dec" aria-label="Decrease quantity">−</button>' +
        '<span>' + i.quantity + '</span>' +
        '<button type="button" data-group="' + gi + '" data-op="inc" aria-label="Increase quantity"' + (maxed ? ' disabled' : '') + '>+</button></div>' +
        discHtml + '</div>' +
        '<div class="ci-side"><span class="ci-price">' +
        (discounted ? '<s>' + money(i.original_line_price) + '</s> ' : '') + money(shown) + '</span>' +
        '<button type="button" class="ci-remove" data-group="' + gi + '" data-op="remove" aria-label="Remove ' + esc(name) + ' size ' + esc(i.variant_title) + '">Remove</button></div></div>';
    }).join('');
    renderUpsell(cart);
  }
  /* One relevant note, never an auto-add: a single tee in the bag, THE TWO live. */
  function renderUpsell(cart) {
    if (!upsellEl) return;
    var singles = cart.items.filter(function (i) { return (OFFER.singles || []).indexOf(i.handle) !== -1; });
    var singleQty = singles.reduce(function (n, i) { return n + i.quantity; }, 0);
    if (OFFER.regular && singleQty % 2 === 1) {
      upsellEl.innerHTML = singleQty === 1
        ? '<p><b>Make it The Two.</b> Add any second tee — any statement, any size — and the pair comes to ' + money(OFFER.twoPrice) + ', ' + money(OFFER.twoSaving) + ' less than buying them individually.</p><a href="/collections/drop-001#statements">Choose a second tee</a>'
        : '<p><b>One more makes another pair.</b> Add a tee and it pairs with your last one — each pair comes to ' + money(OFFER.twoPrice) + '.</p><a href="/collections/drop-001#statements">Add another tee</a>';
      upsellEl.hidden = false;
    } else {
      upsellEl.hidden = true;
      upsellEl.innerHTML = '';
    }
  }
  function refreshCart() { return fetchCart().then(renderCart).catch(function () {}); }

  function setBusy(on) {
    busy = on;
    if (drawer) {
      drawer.classList.toggle('is-busy', on);
      drawer.setAttribute('aria-busy', String(on));
    }
  }
  function openCart() {
    if (!drawer) return;
    markIntent();
    document.body.classList.add('cart-open');
    lastFocus = document.activeElement;
    drawer.classList.add('open'); overlay.classList.add('open');
    drawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    (closeBtn || drawer).focus();
  }
  function closeCart() {
    if (!drawer) return;
    document.body.classList.remove('cart-open');
    drawer.classList.remove('open'); overlay.classList.remove('open');
    drawer.setAttribute('inert', '');
    document.body.style.overflow = '';
    showMsg('');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  cartBtns.forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(openCart); });
  });
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeCart();
  });

  function changeLine(key, qty, lineIndex) {
    var body = lineIndex ? { line: lineIndex, quantity: qty } : { id: key, quantity: qty };
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : cartError(r); });
  }

  if (drawer) {
    drawer.setAttribute('inert', '');
    /* Whole-cart update: quantities for every line, in cart order. */
    var updateAll = function (qtys) {
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: qtys })
      }).then(function (r) { return r.ok ? r.json() : cartError(r); });
    };
    var qtysWithout = function (g) {
      var drop = {}; g.lines.forEach(function (l) { drop[l.index] = true; });
      return lastCart.items.map(function (it, idx) { return drop[idx + 1] ? 0 : it.quantity; });
    };
    var addUnits = function (g, qty, id) {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id || g.first.variant_id, quantity: qty, properties: g.first.properties || {} }] })
      }).then(function (r) { return r.ok ? r.json() : cartError(r); });
    };
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-group]');
      if (!t || busy || !lastCart) return;
      var g = lastGroups[+t.dataset.group];
      if (!g) return;
      var op = t.dataset.op;
      setBusy(true); showMsg('');
      var job;
      if (op === 'inc') job = addUnits(g, 1).then(fetchCart);
      else if (op === 'dec') {
        var last = g.lines[g.lines.length - 1];
        job = changeLine(null, last.quantity - 1, last.index);
      } else job = updateAll(qtysWithout(g));
      job.then(function (cart) {
        renderCart(cart);
        announce(op === 'remove' ? 'Removed from your bag' : 'Bag updated');
      }).catch(function (err) {
        showMsg(err.message);
        announce(err.message);
        return refreshCart();
      }).then(function () { setBusy(false); });
    });
    /* Size change in place. Remove the old line first (its key is only valid
       until the cart changes — a pair discount forming re-keys lines), then add
       the new size with the same quantity and line properties. If the new size
       cannot be added, the old line is put back, so nothing else in the bag is
       touched and the customer never silently loses a tee. */
    drawer.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-line-size]');
      if (!sel || busy || !lastCart) return;
      var g = lastGroups[+sel.dataset.lineSize];
      if (!g) return;
      var newId = +sel.value;
      if (newId === g.first.variant_id) return;
      setBusy(true); showMsg('');
      updateAll(qtysWithout(g))
        .then(function () {
          return addUnits(g, g.quantity, newId).catch(function (err) {
            return addUnits(g, g.quantity).then(function () { throw err; }, function () { throw err; });
          });
        })
        .then(fetchCart)
        .then(function (cart) { renderCart(cart); announce('Size changed'); })
        .catch(function (err) { showMsg(err.message); announce(err.message); return refreshCart(); })
        .then(function () { setBusy(false); });
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(drawer.querySelectorAll('button, a[href], input, select'), function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- one add function for every entry point ---------- */
  var addInFlight = false;
  function addItems(items, label, ctx) {
    if (addInFlight) return Promise.resolve(false);
    addInFlight = true;
    markIntent();
    var btn = ctx && ctx.button;
    var fail = ctx && ctx.fail;
    var btnText = btn ? btn.innerHTML : '';
    if (fail) { fail.hidden = true; fail.textContent = ''; }
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : cartError(r); })
      .then(function () { return refreshCart(); })
      .then(function () {
        announce((label || 'Item') + ' added to your bag');
        openCart();
        return true;
      })
      .catch(function (err) {
        var m = (err && err.message) || 'Could not add to your bag — please try again.';
        if (fail) { fail.textContent = m; fail.hidden = false; }
        announce(m);
        return false;
      })
      .then(function (ok) {
        addInFlight = false;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = btnText; }
        return ok;
      });
  }
  function addVariant(variantId, label, ctx) {
    return addItems([{ id: +variantId, quantity: 1 }], label, ctx);
  }

  /* ---------- PDP buy form + sticky bar (size kept in sync) ---------- */
  var buyForm = document.querySelector('[data-buy-form]');
  var stickyBuy = document.querySelector('.sticky-buy');
  if (buyForm) {
    /* The radios stay `required` for the no-JS form post; with JS the theme's own
       inline message replaces the browser's validation bubble. */
    buyForm.noValidate = true;
    var sizeField = buyForm.querySelector('.size-field');
    var sizeError = buyForm.querySelector('[data-size-error]');
    var buyBtn = buyForm.querySelector('button[type="submit"]');
    var buyFail = buyForm.querySelector('[data-add-fail]');
    var sbBtn = stickyBuy && stickyBuy.querySelector('[data-sticky-add]');
    var sbSize = stickyBuy && stickyBuy.querySelector('[data-sticky-size]');
    var chosenSize = function () { return buyForm.querySelector('.size-options input:checked'); };
    var needSize = function () {
      if (!sizeField) return;
      sizeField.classList.add('needs-size');
      if (sizeError) sizeError.hidden = false;
      sizeField.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
      var first = buyForm.querySelector('.size-options input:not([disabled])');
      if (first) window.setTimeout(function () { first.focus({ preventScroll: true }); }, 420);
    };
    var syncSticky = function () {
      var c = chosenSize();
      if (sbSize) { sbSize.hidden = !c; sbSize.textContent = c ? ' · ' + (c.dataset.title || '') : ''; }
      if (sbBtn) sbBtn.textContent = c ? (sbBtn.dataset.labelAdd || 'Add to bag') + ' — ' + (c.dataset.title || '') : (sbBtn.dataset.labelChoose || 'Choose size');
    };
    var switchLinks = document.querySelectorAll('[data-switch]');
    var carrySize = function (t) {
      switchLinks.forEach(function (a) {
        try { var u = new URL(a.href, location.origin); if (t) u.searchParams.set('size', t); else u.searchParams.delete('size'); a.href = u.pathname + u.search; } catch (e) {}
      });
      document.querySelectorAll('.pdp-four-list [data-four-echo]').forEach(function (e) { e.textContent = t ? 'Size ' + t : 'choose a size'; });
    };
    buyForm.addEventListener('change', function (ev) {
      if (ev.target && ev.target.name === 'id') {
        if (sizeField) sizeField.classList.remove('needs-size');
        if (sizeError) sizeError.hidden = true;
        if (buyFail) buyFail.hidden = true;
        carrySize(ev.target.dataset.title || '');
        syncSticky();
        document.dispatchEvent(new CustomEvent('ws:size', { detail: { handle: buyForm.dataset.handle, size: ev.target.dataset.title } }));
      }
    });
    syncSticky();
    /* A size chosen on the previous statement (?size=L from the switcher) is
       re-selected here, only if that size exists and is in stock. */
    (function () {
      var want = null;
      try { want = new URLSearchParams(location.search).get('size'); } catch (e) {}
      if (!want) return;
      var r = Array.prototype.filter.call(buyForm.querySelectorAll('.size-options input'), function (x) { return x.dataset.title === want && !x.disabled; })[0];
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    })();
    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var size = chosenSize();
      if (!size) { needSize(); announce('Choose a size first'); return; }
      addVariant(size.value, buyForm.dataset.name + ', size ' + (size.dataset.title || ''), { button: buyBtn, fail: buyFail });
    });
    /* Sticky bar with no size: open a small M/L/XL sheet right there instead of
       sending the customer back up the page. Picking a size selects the same
       radio in the buy panel, so the two can never disagree. */
    var sheet = stickyBuy && stickyBuy.querySelector('[data-sticky-sheet]');
    var closeSheet = function () { if (sheet) { sheet.hidden = true; if (sbBtn) sbBtn.setAttribute('aria-expanded', 'false'); } };
    if (sheet) {
      if (sbBtn) sbBtn.setAttribute('aria-expanded', 'false');
      sheet.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sheet-size]');
        if (!b || b.disabled) return;
        var radio = buyForm.querySelector('.size-options input[value="' + b.dataset.sheetSize + '"]');
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        closeSheet();
        if (sbBtn) sbBtn.focus();
      });
    }
    if (sbBtn) sbBtn.addEventListener('click', function () {
      var size = chosenSize();
      if (!size) {
        if (sheet) {
          var opening = sheet.hidden;
          sheet.hidden = !opening;
          sbBtn.setAttribute('aria-expanded', String(opening));
          if (opening) { var f = sheet.querySelector('[data-sheet-size]:not([disabled])'); if (f) f.focus(); }
        } else needSize();
        return;
      }
      addVariant(size.value, buyForm.dataset.name + ', size ' + (size.dataset.title || ''), { button: sbBtn, fail: buyFail }).then(function () { syncSticky(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    if (stickyBuy && 'IntersectionObserver' in window) {
      /* Show the sticky bar only once the real buy block has scrolled ABOVE the viewport. */
      var sio = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var rootTop = e.rootBounds ? e.rootBounds.top : 0;
        var passed = !e.isIntersecting && e.boundingClientRect.bottom <= rootTop;
        stickyBuy.classList.toggle('show', passed);
        if (passed) stickyBuy.removeAttribute('inert'); else { stickyBuy.setAttribute('inert', ''); closeSheet(); }
      }, { rootMargin: '-70px 0px 0px 0px' });
      sio.observe(buyForm);
    }
  }

  /* ---------- homepage positions: size select → single Add to bag ---------- */
  document.querySelectorAll('[data-pos-buy]').forEach(function (buy) {
    var addBtn = buy.querySelector('[data-pos-add]');
    var sizes = Array.prototype.slice.call(buy.querySelectorAll('[data-pos-size]'));
    var chosen = null;
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        chosen = b; markIntent();
        sizes.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('selected', on);
          x.setAttribute('aria-pressed', String(on));
        });
        addBtn.disabled = false;
        addBtn.textContent = 'Add to bag — ' + b.dataset.size;
      });
    });
    addBtn.addEventListener('click', function () {
      if (!chosen) return;
      addVariant(chosen.dataset.posSize, buy.dataset.statement + ', size ' + chosen.dataset.size, { button: addBtn });
    });
  });

  /* quick add buttons carry a variant id */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () { addVariant(btn.dataset.quickAdd, btn.dataset.name, { button: btn }); });
  });

  /* ---------- THE FOUR ---------- */
  document.querySelectorAll('[data-four-form]').forEach(function (form) {
    var field = form.querySelector('.size-field');
    var err = form.querySelector('[data-size-error]');
    var fail = form.querySelector('[data-add-fail]');
    var block = form.closest('.ws-four');
    form.addEventListener('change', function (ev) {
      if (ev.target && ev.target.type === 'radio') {
        if (field) field.classList.remove('needs-size');
        if (err) err.hidden = true;
        if (block) block.querySelectorAll('[data-four-echo]').forEach(function (e) { e.textContent = 'Size ' + (ev.target.dataset.title || ''); });
      }
    });
    var btn = form.querySelector('[data-four-add]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var chosen = form.querySelector('input[type="radio"]:checked');
      if (!chosen) {
        if (field) {
          field.classList.add('needs-size');
          if (err) err.hidden = false;
          field.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
          var first = form.querySelector('input[type="radio"]:not([disabled])');
          if (first) window.setTimeout(function () { first.focus({ preventScroll: true }); }, 420);
        }
        return;
      }
      addVariant(chosen.value, (form.dataset.fourName || 'The Four') + ', size ' + (chosen.dataset.title || ''), { button: btn, fail: fail });
    });
  });

  /* ---------- THE TWO: two statements, two sizes, one add ---------- */
  document.querySelectorAll('[data-two-builder]').forEach(function (b) {
    var data = {};
    try { data = JSON.parse(b.querySelector('[data-two-data]').textContent); } catch (e) { return; }
    var slots = Array.prototype.slice.call(b.querySelectorAll('[data-two-slot]'));
    var summary = b.querySelector('[data-two-summary]');
    var btn = b.querySelector('[data-two-add]');
    var fail = b.querySelector('[data-two-fail]');
    var touched = {};
    function pick(slot) {
      var s = slot.querySelector('.ws-two__stmts input:checked');
      var z = slot.querySelector('.ws-two__sizes input:checked');
      return { handle: s ? s.value : null, size: z ? z.value : null };
    }
    function refresh() {
      slots.forEach(function (slot) {
        var p = pick(slot);
        var prod = p.handle && data[p.handle];
        slot.querySelectorAll('.ws-two__sizes input').forEach(function (inp) {
          var v = prod && prod.sizes[inp.value];
          var out = !!(prod && (!v || !v.available));
          inp.disabled = out;
          var lab = inp.nextElementSibling;
          if (lab) lab.classList.toggle('is-out', out);
          if (out && inp.checked) inp.checked = false;
        });
      });
      var a = pick(slots[0]), c = pick(slots[1]);
      var name = function (p) { return p.handle ? data[p.handle].name + (p.size ? ' · ' + p.size : '') : '…'; };
      if (summary) summary.textContent = (a.handle || c.handle) ? name(a) + '  +  ' + name(c) : 'Choose two statements and a size for each.';
      /* The two chosen garments side by side, with their sizes, above the total. */
      [a, c].forEach(function (p, n) {
        var box = b.querySelector('[data-two-pick="' + (n + 1) + '"]');
        if (!box) return;
        if (!p.handle) { box.innerHTML = '<span class="ws-two__ph">' + (n === 0 ? 'First tee' : 'Second tee') + '</span>'; box.classList.remove('is-set'); return; }
        var d = data[p.handle];
        box.innerHTML = (d.img ? '<img src="' + d.img + '" alt="" width="60" height="75">' : '') +
          '<span><b>' + d.name + '</b>' + (p.size ? 'Size ' + p.size : '<em>Choose a size</em>') + '</span>';
        box.classList.add('is-set');
      });
      var same = b.querySelector('[data-two-same]');
      if (same) same.hidden = !a.size;
      if (same && a.size) same.textContent = 'Use ' + a.size + ' for both';
    }
    var sameBtn = b.querySelector('[data-two-same]');
    if (sameBtn) sameBtn.addEventListener('click', function () {
      var a = pick(slots[0]); if (!a.size) return;
      var inp = slots[1].querySelector('.ws-two__sizes input[value="' + a.size + '"]');
      if (inp && !inp.disabled) {
        inp.checked = true; touched['2'] = true;
        var er = slots[1].querySelector('[data-two-error]'); if (er) er.hidden = true;
        slots[1].classList.remove('needs-size');
        refresh();
        announce('Second tee set to size ' + a.size);
      } else if (inp) {
        announce(a.size + ' is sold out in that statement');
      }
    });
    b.addEventListener('change', function (e) {
      var slot = e.target.closest('[data-two-slot]');
      if (slot) {
        if (e.target.closest('.ws-two__sizes')) touched[slot.dataset.twoSlot] = true;
        var er = slot.querySelector('[data-two-error]'); if (er) er.hidden = true;
        slot.classList.remove('needs-size');
      }
      if (fail) fail.hidden = true;
      refresh();
    });
    /* On a product page the first tee is the one being viewed; its size follows
       the buy panel until the customer sets it here themselves. */
    document.addEventListener('ws:size', function (e) {
      var slot = slots[0]; if (!slot || touched['1'] || !e.detail) return;
      var inp = slot.querySelector('.ws-two__sizes input[value="' + e.detail.size + '"]');
      if (inp && !inp.disabled) { inp.checked = true; refresh(); }
    });
    btn.addEventListener('click', function () {
      var ok = true, items = [], labels = [];
      slots.forEach(function (slot, n) {
        var p = pick(slot);
        var er = slot.querySelector('[data-two-error]');
        var which = n === 0 ? 'first' : 'second';
        var msg = !p.handle ? 'Choose a statement for the ' + which + ' tee.' : (!p.size ? 'Choose a size for the ' + which + ' tee.' : '');
        if (msg) {
          ok = false; slot.classList.add('needs-size');
          if (er) { er.textContent = msg; er.hidden = false; }
          return;
        }
        var v = data[p.handle].sizes[p.size];
        items.push(v.id); labels.push(data[p.handle].name + ' ' + p.size);
      });
      if (!ok) {
        var firstBad = b.querySelector('.needs-size');
        if (firstBad) firstBad.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      var merged = items[0] === items[1] ? [{ id: items[0], quantity: 2 }] : [{ id: items[0], quantity: 1 }, { id: items[1], quantity: 1 }];
      addItems(merged, 'The Two: ' + labels.join(' and '), { button: btn, fail: fail });
    });
    refresh();
  });

  /* PDP "The Two" jump: land on the builder with the first tee already set. */
  document.querySelectorAll('[data-two-jump]').forEach(function (a) {
    a.addEventListener('click', function () { markIntent(); });
  });

  refreshCart();

  window.__wsReady = performance.now();
})();
